export default function ({ title, text, link }) {
  const isPopup = typeof link === 'string' && link.indexOf('/popups/') === 0;
  const popupId = isPopup ? link.split('/').pop().replace('.html', '') : '';
  const footer = `
    <div class="description__footer">
      <a class="${isPopup ? 'link js-popup-open' : 'link'}" href="${link}"${isPopup ? ` data-popup-id="${popupId}"` : ''}>
        <svg class="link__icon" width="20" height="17">
          <use xlink:href="#arrows"></use>
        </svg>
        <div class="link__caption">Подробнее</div>
      </a>
    </div>
  `;

  return `
    <div class="description _small">
      <div class="description__title">${title}</div>
      <div class="description__text">${text}</div>
      ${link ? footer : ''}
    </div>
  `;
}
